import styled from 'styled-components';

export const RescheduleInfoMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l35} ${props.theme.spacing.large.l35};
    `
);

export const InfoBlockHeadWrap = styled.div(
    props => `
        width:100%;
        dispaly: flex;
        flex-direction: column;
    `
);

export const InfoBlockHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
        padding-bottom: ${props.theme.spacing.small.s3};
    `
);

export const InfoBlockSubText = styled.p(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.base};
    `
);

export const RefundBtnWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding-top: ${props.theme.spacing.large.l30};
        cursor: ${props.disabled ? '' : 'pointer'};
        pointer-events: ${props.disabled ? 'none' : ''};
        opacity: ${props.disabled ? '0.3' : '1'};
    `
);

export const RefundBtn = styled.button(
    props => `
        outline: none;
        border: none;
        border-radius: 4rem;
        box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2);
        background-image: linear-gradient(95deg, #53b2fe 1%, #065af3 130%);
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l30};
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        text-transform: uppercase;
        align-self: flex-end;
        cursor: pointer;
    `
);

export const OldNameWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding: ${props.theme.spacing.large.l30} 0;
    `
);

export const OldNameTitle = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const OldNameText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.black.base};
        padding-left: ${props.theme.spacing.large.l30};
    `
);

export const NewNameOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding-top: ${props.theme.spacing.large.l20};
        padding-bottom: ${props.theme.spacing.large.l30};
    `
);

export const NameNameTitle = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const NewNameInnerWrap = styled.div(
    props => `
        width:80%;
        display: flex;
        padding-left: ${props.theme.spacing.large.l15};
    `
);

export const NewFirstNameWrap = styled.div(
    props => `
        padding-right: ${props.theme.spacing.base};
        width: 40%;
        display: flex;
        flex-direction: column;
    `
);

export const NewLastNameWrap = styled.div(
    props => `
        padding-right: ${props.theme.spacing.base};
        width: 40%;
        display: flex;
        flex-direction: column;
    `
);

export const NewNameInput = styled.input(
    props =>`
    width: 100%;
    height: 4.2rem;
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid ${props.theme.colors.grey.lighte7};
    background-color: ${props.theme.colors.white.base};
    border-radius: 0;
    font-size: ${props.theme.font.large.font14};
    padding: 0 ${props.theme.spacing.base} ${props.theme.spacing.large.l25};
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    position: relative;
    cursor: pointer;
    ::placeholder {
      lin-height: ${props.theme.font.lineHeight.large};
      font-size: ${props.theme.font.large.font16};
      color: ${props.theme.colors.grey.dark74};
      font-weight: normal;
      overflow: visible;
    }
    :focus{
        outline: none;
    }
    @media only screen and (min-width: 320px) and (max-width: 991px) {
      font-size: ${props.theme.font.large.font14};
    }
    opacity: ${props.disabled ? '0.4' : '1'};
    pointer-events: ${props.disabled ? 'none' : ''};
    border-color: ${props.hasError ? props.theme.colors.red.base : ''};
    text-transform: ${props.isPAN ? props.theme.font.textTransform.upper : ''};
  `);


export const UserInfoForm = styled.form(
    props => `
          width:100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: column;
      `,
);

export const ErrorText = styled.span(
    props => `
          color: ${props.theme.colors.red.base};
          font-size: ${props.theme.font.small.font10};
      `,
);